import React from 'react'
import { Link } from 'react-router-dom'
import { heroImages } from '../../helpers/heroimages'

export const HeroCard = ({
    id,
    superhero,
    publisher,
    alter_ego,
    first_appearance,
    characters
}) => {

    return (
        <div className='card ms-3 caja-inicio' style={{ maxWidth: 540 }}>
            <div className='row no-gutters'>
                <div className='col-md-4'>
                    <img 
                    //  src={`../../assets/heroes/${id}.jpg`} className='card-img' alt={superhero} 
                    src={heroImages(`./${ id }.jpg`).default} className='card-img' alt={superhero}

                    />
                </div>

                <div className='card-body'>

                    <h5 className='card-title'>{superhero}</h5>

                    <Link to={`./hero/${id}`}>
                        Mas...
                    </Link>

                </div>

            </div>

        </div >
    )
}
